import React from 'react';
import { Circle } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
export function BenefitsTicker() {
  const {
    t
  } = useTranslations();
  const benefits = [t('ticker.fastApprovals'), t('ticker.noUpfront'), t('ticker.softCredit'), t('ticker.flexible'), t('ticker.sameDay'), t('ticker.approval')];
  return <div className="w-full bg-gray-50 border-y border-gray-100 py-6 overflow-hidden" data-id="element-21">
      <div className="max-w-7xl mx-auto px-4 overflow-hidden" data-id="element-22">
        <div className="flex items-center justify-between space-x-8 animate-scroll whitespace-nowrap md:justify-center md:animate-none md:flex-wrap md:whitespace-normal" data-id="element-23">
          {benefits.map((benefit, index) => <div key={index} className="flex items-center space-x-2" data-id="element-24">
              <Circle className="w-2 h-2 fill-[#00E676] text-[#00E676]" data-id="element-25" />
              <span className="text-sm md:text-base font-semibold text-gray-700 uppercase tracking-wide" data-id="element-26">
                {benefit}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}